import { useDispatch, useSelector, useStore } from "react-redux";
import {
	toggleSingle as toggleSingleAction,
	toggleDoubles as toggleDoublesAction
} from "./tennis-actions";

const useTennisTeamContext = ({ team: contextTeam }) => {
	const { id } = contextTeam;

	const store = useStore();
	const dispatch = useDispatch();

	const getTeamContext = (state, teamId) => {
		return state.teamContext.teams[teamId] || {};
	};

	const useTeam = () => useSelector((state) => getTeamContext(state, id).team);

	const useSingle = () =>
		useSelector((state) => getTeamContext(state, id).single);

	const useDoubles = () =>
		useSelector((state) => getTeamContext(state, id).doubles);

	const toggleSingle = (player) => {
		const { game } = store.getState().game;
		toggleSingleAction(game.id, id, player, dispatch);
	};

	const toggleDoubles = (player) => {
		const { game } = store.getState().game;
		toggleDoublesAction(game.id, id, player, dispatch);
	};

	const state = {
		team: useTeam,
		single: useSingle,
		doubles: useDoubles
	};

	return {
		state,
		toggleSingle,
		toggleDoubles
	};
};

export { useTennisTeamContext };
